import { Vue, Component } from 'vue-property-decorator'
import applicationStore from '@/store/modules/applications/applicationStore'
import APP_UTILITIES from '@/utilities/commonFunctions'
import formsStore from '@/store/modules/forms/formsStore'

@Component
export default class ManageApplication extends Vue {
  /* istanbul ignore next */
  get siteList() {
    return applicationStore.sitesList
  }

  /* istanbul ignore next */
  get applicationData() {
    return applicationStore.applicationDataInfo
  }

  /* istanbul ignore next */
  mounted() {
    applicationStore.getSitesByProgramId(this.applicationData.programId)
    applicationStore.getScholarsByGuardian()
  }

  /* istanbul ignore next */
  destroyed() {
    applicationStore.mutateChildrenDropdown({
      ...applicationStore.childrenDropdownObj,
      id: 0,
      value: 'Select child'
    })
    formsStore.resetApplication()
    APP_UTILITIES.removeSpecificCookie('outStandingItems')
    APP_UTILITIES.removeSpecificCookie('outStandingItemIndex')
    APP_UTILITIES.removeSpecificCookie('disableDocument')
    applicationStore.mutateDisableSite(false)
    applicationStore.mutateIsOutstandingItems(false)
    applicationStore.mutateScholarData('')
    applicationStore.mutateDocumentArray([])
    applicationStore.mutateScholarDocument({})
  }
}
